import React, { useEffect, useState } from "react"
import { sanitizeInnerHtml } from "@/utils/helper"
import { getShortenedUrl } from "@/utils/location"
const Text = props => {
  const [dataVal, setDataVal] = useState("")

  const {
    data: { text = "", appliedCssClassNames = "", richText = false } = {},
    omniQRParams,
    isOmnichannel,
  } = props
  const removeHtmlExtension = async () => {
    const newData = await getShortenedUrl(text)
    if (isOmnichannel && omniQRParams.qrId !== "") {
      const updatedDataVal = newData.replace(
        "Ref+ID%3A+",
        `Ref+ID%3A+${encodeURIComponent(omniQRParams.qrId)}`
      )
      setDataVal(updatedDataVal)
    } else {
      setDataVal(newData)
    }
  }
  useEffect(() => {
    if (richText) {
      removeHtmlExtension()
    }
  }, [richText])

  return (
    <div className={`text ${appliedCssClassNames ? appliedCssClassNames : ""}`}>
      {richText ? (
        <div className="cmp-text">{sanitizeInnerHtml(dataVal)}</div>
      ) : (
        <div className="cmp-text">
          <p className="cmp-text__paragraph" aria-label={text}>
            {text}
          </p>
        </div>
      )}
    </div>
  )
}

export default Text
